import * as React from 'react';
var DialogContext = /*#__PURE__*/React.createContext({});

if (process.env.NODE_ENV !== 'production') {
  DialogContext.displayName = 'DialogContext';
}

export default DialogContext;